import shoes1 from '../../assets/img/img_products/1.png'
import shoes2 from '../../assets/img/img_products/2.png'
import shoes3 from '../../assets/img/img_products/3.png'
import shoes4 from '../../assets/img/img_products/4.png'
import shoes5 from '../../assets/img/img_products/5.png'
import shoes6 from '../../assets/img/img_products/6.png'
import shoes7 from '../../assets/img/img_products/7.png'
import shoes8 from '../../assets/img/img_products/8.png'
import shoes9 from '../../assets/img/img_products/9.png'
import shoes10 from '../../assets/img/img_products/10.png'

import shoes11 from '../../assets/img/img_products/11.png'
import shoes12 from '../../assets/img/img_products/12.png'
import shoes13 from '../../assets/img/img_products/13.png'
import shoes14 from '../../assets/img/img_products/14.png'
import shoes15 from '../../assets/img/img_products/15.png'
import shoes16 from '../../assets/img/img_products/16.png'
import shoes17 from '../../assets/img/img_products/17.png'
import shoes18 from '../../assets/img/img_products/18.png'
import shoes19 from '../../assets/img/img_products/19.png'
import shoes20 from '../../assets/img/img_products/20.png'

const shoes = [shoes1,shoes2, shoes3, shoes4, shoes5, shoes6, shoes7, shoes8, shoes9,
    shoes10, shoes11, shoes12, shoes13, shoes14, shoes15, shoes16, shoes17, shoes18,
    shoes19, shoes20]

export default {
    shoes
}